工厂发货模块
